const crud = { c: false, r: false, u: false, d: false };

export const accounts = Object.freeze({
  account: { ...crud },
});
